@if (type === 'popup') {
  <div class="w-100">
    @if (isColumnOption) {
      <kendo-popup
        class="popup"
        #popup
        [anchor]="anchor"
        [anchorAlign]="anchorAlign()"
        [popupAlign]="popupAlign()"
      style="
        width: calc(100% - 48px - 56px);
        margin-top: 4px;
        padding-right: 4px;
      "
        >
        <div class="px-2 pt-2 d-flex justify-content-between">
          <div class="font-weight-bold">{{ 'HOME_COMPONENTS.DATA_SELECTOR.ADDITIONAL_FILTERS' | translate }}</div>
          <fa-icon
            role="button"
            class="px-2 cursor-pointer"
            tabindex="0"
            (click)="onClose($event)"
            [icon]="faTimes"
          ></fa-icon>
        </div>
        <ng-template [ngTemplateOutlet]="search"></ng-template>
        <ng-template [ngTemplateOutlet]="actions"></ng-template>
        <div
          class="mt-1 columns-config-pop-container columns-config-pop-container-height"
          >
          <ng-template [ngTemplateOutlet]="fields"></ng-template>
        </div>
      </kendo-popup>
    }
  </div>
}
@if (type === 'window') {
  @if (isColumnOption) {
    <kendo-window
      (close)="onClose($event)"
      [minWidth]="250"
      [minHeight]="533"
      [width]="350"
      [(top)]="windowTop"
      [(state)]="state"
      [(height)]="height"
      >
      <ng-template [ngTemplateOutlet]="search"></ng-template>
      <ng-template [ngTemplateOutlet]="actions"></ng-template>
      <div
        class="mt-1"
      [ngStyle]="{
        height:
          state !== 'maximized' ? height - 175 + 'px' : 'calc(100vh - 175px)'
      }"
      [ngClass]="{
        'columns-config-pop-container': state !== 'maximized',
        'columns-config-pop-maximized-container': state === 'maximized'
      }"
        >
        <ng-template [ngTemplateOutlet]="fields"></ng-template>
      </div>
      <ng-template [ngTemplateOutlet]="submitActions"></ng-template>
    </kendo-window>
  }
}

<ng-template #search>
  <div class="p-2">
    <kendo-textbox
      [placeholder]="'HOME_COMPONENTS.COMMON.SEARCH' | translate"
      (valueChange)="onColumnsSearchChange($event)"
      >
      <ng-template kendoTextBoxSuffixTemplate>
        <fa-icon class="pe-2" [icon]="faSearch"></fa-icon>
      </ng-template>
    </kendo-textbox>
  </div>
</ng-template>

<ng-template #actions>
  <div class="px-2 pb-2 d-flex justify-content-start border-bottom">
    <button
      kendoButton
      class="small-text"
      [themeColor]="'base'"
      size="small"
      [fillMode]="'outline'"
      (click)="setCheckedForAllColumns(false)"
      >
      {{ 'HOME_COMPONENTS.DATA_SELECTOR.CLEAR_ALL' | translate }}
    </button>
    <button
      kendoButton
      class="small-text ms-2"
      [themeColor]="'primary'"
      size="small"
      (click)="setCheckedForAllColumns(true)"
      >
      {{ 'HOME_COMPONENTS.DATA_SELECTOR.SELECT_ALL' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #submitActions>
  <div class="p-2 d-flex justify-content-end border-top bg-light">
    <button
      kendoButton
      class="small-text"
      [themeColor]="'base'"
      size="small"
      (click)="onClose($event)"
      >
      {{ 'HOME_COMPONENTS.COMMON.CANCEL' | translate }}
    </button>
    <button
      kendoButton
      class="small-text ms-2"
      [themeColor]="'primary'"
      size="small"
      (click)="saveColumnsConfig()"
      >
      {{ 'HOME_COMPONENTS.COMMON.SAVE' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #fields>
  @for (item of dataFiltered | OFilterByTitle : searchInput; track item) {
    <div
      class="column-options-items m-2 d-flex align-items-start"
      >
      <input
        type="checkbox"
        [id]="item.title"
        [checked]="item.checked"
        (change)="checkChange(item)"
        kendoCheckBox
        class="o-mt-4"
        />
      <kendo-label
        class="k-checkbox-label"
        [for]="item.title"
        [text]="item.title"
      ></kendo-label>
    </div>
  }
</ng-template>
